module.exports = __webpack_public_path__ + "static/media/mat.efe41ff4.svg";